import { render } from "./B00000.vue?vue&type=template&id=2976f260&ts=true"
import script from "./B00000.vue?vue&type=script&lang=ts"
export * from "./B00000.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src613357358/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__